import { Imatge } from '@portal-internet/components';
import Boto from '../Boto/Boto';
import styles from './calltoaction.module.scss';
import clsx from 'clsx';
import Icona from '../ui/Icona';

const CallToAction = (props) => {
    const { titol, text, boto, estil, id, icona } = props;

    const stylesContent = clsx({
        [styles.content]: true,
        [styles[estil]]: !!estil
    });

    const stylesBoto = clsx({
        [styles.boto]: true,
        [styles[boto?.estil]]: !!estil
    });
    return (
        <div className={stylesContent} data-testid={`call-to-action-${id}`}>
            {icona && (
                <div className={styles.icona}>
                    <Imatge src={icona} width='80' height='81' />
                </div>
            )}
            {titol && (
                <h3 data-testid={`call-to-action-${id}-titol`} className={styles.titol}>
                    {titol}
                </h3>
            )}
            {text && (
                <p data-testid={`call-to-action-${id}-text`} className={styles.entrada}>
                    {text}
                </p>
            )}

            {boto && (
                <Boto
                    link={boto.href}
                    route={boto.route}
                    className={stylesBoto}
                    text={boto.text}
                    icona={boto.icona}
                    novaFinestra={boto.novaFinestra}
                    isIconaBlanc={boto.iconaBlanc}
                    altIcona={boto.text}
                    dataTestId={`call-to-action-${id}-boto`}
                    isIconaDreta={boto.iconaDreta}
                    fons={boto.fons}
                />
            )}
        </div>
    );
};

export default CallToAction;
